import React from 'react';


class GenderPicker extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.parseValue = this.parseValue.bind(this);
    }

    parseValue(value) {
        if(value == '' || value == 'false' || !value) {
            value = 'male';
        }

        return value;
    }

    handleChange(e) {
        this.props.handleRuleChange(this.props.index,'value',e.target.value);
    }

    render() {
        return (
            <div>
                <select className="form-control" value={this.parseValue(this.props.rule.value)} onChange={this.handleChange}>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                </select>
            </div>
        );
    }


}

export default GenderPicker;




// WEBPACK FOOTER //
// ./containers/segments/Rules/GenderPicker.js